module.exports = __webpack_public_path__ + "static/media/GDocsCookieNotice_ID.67ffaf2b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff_PDF/GDocsCookieNotice_ID.pdf
// module id = 695
// module chunks = 4